import { exportJSON } from './ExportJSON';

export type BankPayload = {
  companyId: string;
  esg_score: number; // 0-100
  co2_reduction: number; // kg
  industry_rating: number; // 0-100
  risk_vector: { transition: number; physical: number; compliance: number }; // 0-1
};

export function generateBankPayload(args: BankPayload): BankPayload {
  return {
    companyId: args.companyId,
    esg_score: clamp0to100(args.esg_score),
    co2_reduction: Math.max(0, args.co2_reduction),
    industry_rating: clamp0to100(args.industry_rating),
    risk_vector: {
      transition: clamp01(args.risk_vector.transition),
      physical: clamp01(args.risk_vector.physical),
      compliance: clamp01(args.risk_vector.compliance)
    }
  };
}

export function exportBankPayload(filenameBase: string, payload: BankPayload) {
  exportJSON(`${filenameBase}`, payload);
}

function clamp0to100(n: number): number { return Math.max(0, Math.min(100, n)); }
function clamp01(n: number): number { return Math.max(0, Math.min(1, n)); }



















